import React from "react";
import { Input } from "@progress/kendo-react-inputs";
import { TextArea } from "@progress/kendo-react-inputs";

const PropertiesInputField = ({ label, type, onChange, value, field }) => (
  <div className="d-flex w-100 mb-2 align-items-center">
    <label className="w-50 fw-semibold fs-sm pe-1">{label}</label>

    {type === "multiline" ? (
      <TextArea
        onChange={onChange}
        value={field?.choicesText || (value ? value.join("\n") : "")}
        style={{
          height: "15vh",
          borderRadius: "10%",
        }}
      />
    ) : (
      <Input
        type={type}
        onChange={onChange}
        value={value}
        className={"" + (type === "number" ? " text-end pe-2" : "")}
      />
    )}
  </div>
);

export default PropertiesInputField;
